function formatGoogleDate(utcIso: string): string {
  return new Date(utcIso)
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}/, '');
}

export function buildGoogleCalendarUrl(params: {
  title: string;
  startUtc: string;
  endUtc: string;
  location?: string;
  description?: string;
}): string {
  const dates = `${formatGoogleDate(params.startUtc)}/${formatGoogleDate(params.endUtc)}`;
  const url = new URL('https://calendar.google.com/calendar/render');
  url.searchParams.set('action', 'TEMPLATE');
  url.searchParams.set('text', params.title);
  url.searchParams.set('dates', dates);
  if (params.location) url.searchParams.set('location', params.location);
  if (params.description) url.searchParams.set('details', params.description);
  return url.toString();
}

export function buildOutlookCalendarUrl(params: {
  title: string;
  startUtc: string;
  endUtc: string;
  location?: string;
  description?: string;
}): string {
  const url = new URL('https://outlook.office.com/calendar/0/action/compose');
  url.searchParams.set('subject', params.title);
  url.searchParams.set('startdt', new Date(params.startUtc).toISOString());
  url.searchParams.set('enddt', new Date(params.endUtc).toISOString());
  if (params.location) url.searchParams.set('location', params.location);
  if (params.description) url.searchParams.set('body', params.description);
  return url.toString();
}
